module.exports = __webpack_public_path__ + "static/assets/0294d390ec3c5a58f3701b3098646770.png";